import React, { useMemo, useState } from 'react';
import { SortOrder, ColumnsType } from 'antd/lib/table/interface';
import { isNil } from 'lodash';

import { SortingDirectionEnum } from 'enums';
import BaseSortButton from 'components/wrappers/BaseSortButton';

export interface ISortParams<S> {
  sortOrder?: SortOrder;
  sortBy?: S;
}

const initialSorParams = {
  sortOrder: undefined,
  sortBy: undefined,
};

export default function useSortColumns<T, S>(
  columns: ColumnsType<T>,
  defaultSortParams = initialSorParams as ISortParams<S>,
) {
  const [sortParams, setSortParams] =
    useState<ISortParams<S>>(defaultSortParams);
  const sortColumns = useMemo(
    () =>
      columns.map((column) => {
        const isActive = column.key === sortParams.sortBy;
        // Enable by default
        const enableSort = isNil(column?.sorter) || !!column?.sorter;

        return {
          ...column,
          title: () => {
            return (
              <BaseSortButton
                sortHidden={!enableSort}
                label={column.title}
                isActive={isActive}
                sortType={sortParams.sortOrder}
              />
            );
          },
          sorter: enableSort,
          sortOrder: isActive ? sortParams.sortOrder : undefined,
          sortDirections: [
            SortingDirectionEnum.Ascend,
            SortingDirectionEnum.Descend,
          ],
        };
      }),
    [columns, sortParams],
  );

  return {
    sortColumns,
    sortParams,
    setSortParams,
  };
}
